/* eslint-disable */
import session from './session';

export default {
  getTariff(tariffId) {
    return session.get(`/api/v1/tariff/${tariffId}`);
  },
  getTariffGroupList(filter) {
    return session.get(`/api/v1/tariff_group/${filter}`);
  },
  createTariffGroup(data) {
    return session.post(`/api/v1/tariff_group/`, data);
  },
  updateTariffGroup(id, data) {
    return session.patch(`/api/v1/tariff_group/${id}/`, data );
  },
  deleteTariffGroup(id) {
    return session.delete(`/api/v1/tariff_group/${id}`);
  },
  getTariffList(filter) {
    return session.get(`/api/v1/tariff/${filter}`);
  },
  createTariff(data) {
    return session.post(`/api/v1/tariff/`, data);
  },
  updateTariff(tariffId, data) {
    return session.patch(`/api/v1/tariff/${tariffId}/`, data );
  },
  deleteTariff(id) {
    return session.delete(`/api/v1/tariff/${id}`);
  },
};
